"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$toast = void 0;
var recoil_1 = require("recoil");
exports.$toast = (0, recoil_1.atom)({
    key: 'toast',
    default: undefined,
});
